import { styled, ThemeProvider, GlobalStyles } from '@mui/material';

import { theme } from './materialUITheme';

import { AppProviders } from './AppProviders';
import { AppModals } from './AppModals';
import { AppRouting } from './AppRouting';
import { OfflineNotification } from './components/OfflineNotification';
import { SnackbarContainer } from './components/SnackbarContainer';

import './variables.css';

const globalStyles = (
  <GlobalStyles
    styles={{
      html: {
        overflow: 'auto',
      },
      body: {
        fontFamily: 'Inter',
        padding: 0,
        margin: 0,
      },
      button: {
        fontFamily: 'Inter',
      },
      '*': {
        boxSizing: 'border-box',
      },
    }}
  />
);

const AppContainer = styled('div')({
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
});

export const App = () => {
  return (
    <ThemeProvider theme={theme}>
      {globalStyles}
      <AppProviders>
        <AppContainer>
          <AppModals />
          <AppRouting />
        </AppContainer>
        <SnackbarContainer />
        <OfflineNotification />
      </AppProviders>
    </ThemeProvider>
  );
};
